import gql from "graphql-tag";

const REMOVE_DIMENSION = gql`
  mutation removeDimension($productId: ID!, $dimensionId: ID!) {
    removeDimension(productId: $productId, dimensionId: $dimensionId)
  }
`;

export default REMOVE_DIMENSION;
